import React from 'react';
import { Switch, Route } from 'react-router-dom';
import Navbar from './modules/Navbar';
import Puskesmas from './pages/pendaftaran-online/puskesmas/Puskesmas';
import PuskesmasSearch from './pages/pendaftaran-online/puskesmas/SearchData';
import GetCLinic from './pages/pendaftaran-online/puskesmas/GetClinic';
import HomePage from './pages/home-page/';
import RumahMakan from './pages/rumahmakan-page/RumahMakan';
import JasaBoga from './pages/jasaboga-page/JasaBoga';
import Content from './pages/pirt-page/Content';
// import Hotel from './pages/hotel-page/Hotel';

const Service = () => {
  return (
    <>
      <Navbar />
      <Switch>
        <Route path='/service' exact component={ HomePage } />
        <Route path='/service/puskesmas' component={ Puskesmas } />
        <Route path='/service/cari-data' component={ PuskesmasSearch } />
        <Route path='/service/pilih-klinik' component={ GetCLinic } />
         <Route path='/service/rumahmakan' component={ RumahMakan } />
         <Route path='/service/jasaboga' component={ JasaBoga } />
        <Route path='/service/pirt' component={ Content } />
        {/* <Route path='/service/hotel' component={ Hotel } /> */}
      </Switch>
    </>
  );
};

export default Service;
